import CoachesSearchWrapper from './coaches-search-wrapper'

export { CoachesSearchWrapper as CoachesSearchNew }
